<template>
    <div>
        <FeeManagment/>
    </div>
</template>

<script>
import FeeManagment from '../../../components/tax/taxRollWorkFile/FeeManagment.vue';

export default {
  name: 'feeManagmentView',
  data() {
    return { };
  },
  components: {
    FeeManagment,
  },
};
</script>
